import { ReactNode, useEffect, useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid';

export type AccordionV2Props = {
  /**
   * a node to be rendered in the special component.
   */
  headingComponent: ReactNode;
  expandComponent: ReactNode;
  /**
   * Custom CSS class names for styling accordion container.
   */
  wrapperClassName?: string;
};

export const AccordionV2 = ({
  headingComponent,
  expandComponent,
  expand = false,
  wrapperClassName,
  onClick,
}: {
  headingComponent: ReactNode;
  expandComponent: ReactNode;
  expand?: boolean;
  wrapperClassName?: string;
  onClick?: () => void;
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(expand);
  }, [expand]);

  const wrapperStyle = `${wrapperClassName} flex flex-col rounded-card border border-container-border`;

  return (
    <div
      className={`rounded-card bg-gray-50 p-2 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700 ${wrapperStyle}`}
    >
      <div
        className="flex w-full cursor-pointer flex-row items-center justify-between"
        onClick={() => {
          setShow(!show);
          onClick?.();
        }}
      >
        <div className={`flex w-full flex-row items-center gap-2`}>
          <div>
            {show ? (
              <ChevronUpIcon className="h-6 w-6 cursor-pointer text-gray-600 dark:text-gray-400" />
            ) : (
              <ChevronDownIcon className="h-6 w-6 cursor-pointer text-gray-600 dark:text-gray-400" />
            )}
          </div>
          {headingComponent}
        </div>
      </div>
      {show && expandComponent}
    </div>
  );
};
